<template>
  <MainLayout selectMenu="12-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Card class="card-container " dis-hover>
        <div slot="title" class="card-title">
          {{ getTranslation('u105') }}
        </div>
      <Row type="flex" justify="center" align="middle" class="table-modify">
        <Col flex="1"></Col>
        <Col flex="1" class="flex-right">
          <div>{{ getTranslation("u106") }}:&nbsp;</div>
        </Col>
        <Col flex="1">
          <Input type="password" password v-model="oldPassword" :placeholder="getTranslation('u106')" size="small" style="width: 50%;"></Input>
        </Col>
        <Col flex="1"></Col>
      </Row>
      <Row type="flex" justify="center" align="middle" class="table-modify">
        <Col flex="1"></Col>
        <Col flex="1"  class="flex-right">
          <div>{{ getTranslation("u107") }}:&nbsp;</div>
        </Col>
        <Col flex="1">
          <Input type="password" password v-model="newPassword" :placeholder="getTranslation('u107')" size="small" style="width: 50%;"></Input>
        </Col>
        <Col flex="1"></Col>
      </Row>
      <Row type="flex" justify="center" align="middle" class="table-modify">
        <Col flex="1"></Col>
        <Col flex="1"  class="flex-right">
          <div>{{ getTranslation("u079") }}:&nbsp;</div>
        </Col>
        <Col flex="1">
          <Input type="password" password v-model="confirmPassword" :placeholder="getTranslation('u079')" size="small" style="width: 50%;" @on-enter="modifyPassword" ></Input>
        </Col>
        <Col flex="1"></Col>
      </Row>
      <Row type="flex" justify="center" align="middle" class="table-modify">
        <Col flex="1"></Col>
        <Col flex="2" class="flex-middle">
          <Button type="primary" size="small" @click="modifyPassword">{{ getTranslation("u105") }}</Button>
        </Col>
        <Col flex="1"></Col>
      </Row>
      </Card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'

import {  Row, Col, Button, Input, Card } from 'view-design';
import axios from 'axios'
import { postJsError } from '@/util/util.js'
import NoAuth from '@/components/NoAuth.vue'
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const';

export default {
  name: 'UserIndex', // 组件名称
  computed: {
    ...mapGetters(['getTranslation']),  
  },
  components: {
    MainLayout,  Row, Col, Button,  NoAuth, Input, Card
  },
  props: {

  },
  data() {
    return {
      hasAuth: true,
      oldPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },
  mounted() {

  },
  created() {
    this.setBreadcrumbItems();
    this.getData();
  },
  methods: {
    getData() {
      
    },
    async modifyPassword() {
      let data = new FormData();
      data.append('old_password', this.oldPassword);
      data.append('new_password', this.newPassword);
      if (!this.oldPassword) {
        this.$Message.error(this.getTranslation('u108'));
        return;
      }
      if (!this.newPassword) {
        this.$Message.error(this.getTranslation('u110'));
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$Message.error(this.getTranslation('u080'));
        return;
      }
      let url = API_URL["userModifyPassword"];
       let res = await axios.post(url, data
      ).catch((err) => {
        postJsError(err)        
      })
      if (res && res.data && res.data.code === 200) {
        this.$Message.success(res.data.msg)
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
      }else if (res && res.data && res.data.code == 3001) {
        this.hasAuth = false;
      } else  if (res && res.data && res.data.msg) {
        this.$Message.error(res.data.msg);
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
    },
    
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['u105']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('u105') }
        ])
      }
    }
  },

}
</script>

<style scoped>
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");
.table-modify {
  margin-top: 10px;

}
</style>